import Swiper from './lib/swiper-bundle.min';

export default () => {
  const $swiperElement = document.getElementById('swiper-plan');
  if (!$swiperElement) return;

  //let $swiperParameter = new Swiper(".swiper-support-thumbnail", {
  let $swiperParameter = {
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 32,
    centeredSlides: false,
    speed: 200,
    navigation: {
      nextEl: ".swiper-plan-button-next",
      prevEl: ".swiper-plan-button-prev",
    },
    thumbs: {
      //swiper: sliderThumbnail,
    },
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      768: {
        centeredSlides: false,
        slidesPerView: 3,
      }
    }
  };

  new Swiper($swiperElement, $swiperParameter);

}
